import React from 'react'
import { Notification } from '@zambezi/sdk/notification'
import { FLAGS } from '@apiEnabler/ob-common/lib/tpps'

import style from './TPPNotification.module.css'

export default function TPPNotification({ tpp }) {
  const TPP_SUSPENDED_WARNING = (
    <Notification
      status="warning"
      className={`${style.notification} js-notification`}
    >
      <ClientName tpp={tpp} /> and all its active connections have been
      suspended. Please contact {tpp.get('clientDisplayName')} for further
      information.
    </Notification>
  )
  return (
    {
      [FLAGS.TPP_SUSPENDED]: TPP_SUSPENDED_WARNING,
      [FLAGS.TPP_CLIENT_SUSPENDED]: TPP_SUSPENDED_WARNING,
      [FLAGS.TPP_REVOKED]: (
        <Notification
          status="warning"
          className={`${style.notification} js-notification`}
        >
          <ClientName tpp={tpp} /> and all its active connections have been
          revoked by Open Banking. Please contact {tpp.get('clientDisplayName')}{' '}
          for further information.
        </Notification>
      ),
    }[tpp.get('flag')] || null
  )
}

function ClientName({ tpp }) {
  return (
    <span className={style.clientName}>{tpp.get('clientDisplayName')}</span>
  )
}
